<!-- Form for Sign in -->
<!-- Loader -->
<ng-container *ngIf = "loading">
  <div class="loading">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</ng-container>
<!-- end of Loader -->
<!-- Start of form -->
<ng-container *ngIf="!loading">
   <!-- <div class="bg-img">     -->

  <form id="modal" style="display: none;width:430px;padding:10px;padding-left: 20px;" class="container" [formGroup]="signInForm" (ngSubmit)="onSubmit()">
  <div style="background-color:white;width:350px;height: 280px;padding:10px;border-radius: 15px;">
 <span onclick="document.getElementById('modal').style.display='none'" class="w3-button w3-display-topright">&times;</span>
  <h1 class="header-login">USER LOG IN</h1>
 <br><br>
    <div class="form-row">
      <!-- <div id="left">
        <label>
          <h2>Select Role</h2>0
        </label>
      </div>
      <div id="right">
        <select class="select">
          <option>Customer</option>
          <option>Moderator</option>
          <option>Tech Expert</option>
        </select>
      </div> -->
      <div id="left">
        <label>
          <h2>User Name</h2>
        </label>
      </div>
      <div id="right">
        <input type="text" formControlName="userName">
        <mat-error *ngIf="signInForm.controls['userName'].invalid && signInForm.controls['userName'].errors.required"> User Name Required </mat-error>
      </div>
    </div>
      <!-- Password -->

      <div class="form-row">
      <div id="left"><label><h2>Password</h2></label></div>
      <div id="right"><input type="password" formControlName="password">
      <mat-error *ngIf="signInForm.controls['password'].invalid && signInForm.controls['password'].errors.required">Password is Required</mat-error>
      <!-- <mat-error *ngIf="signInForm.controls['password'].invalid && signInForm.controls['password'].errors.minlength">Password must be 8 characters</mat-error> -->



    </div>
      </div>

    <button type="submit" id="login" class="btn" >Login</button>
    <mat-error *ngIf="serverErrorMessages">{{serverErrorMessages}}</mat-error><br>
    <span><a id="fgtpwd" routerLinkActive="active" [routerLink]='["/forgotpwd"]'>Forgot Password</a></span>
    <!-- <span><button  id="signup" routerLinkActive="active" [routerLink]='["/land"]'>Sign Up Here</button></span> -->
    </div>
    <br>
    </form>

   <!-- <div class="container1" id="modal1"  style="display: none;width:430px;" [formGroup]="signInForm" (ngSubmit)="onSubmit()">
    <div style="background-color:white;width:350px;height: 280px;padding:10px;border-radius: 15px;">
    <span onclick="document.getElementById('modal1').style.display='none'" class="w3-button w3-display-topright">&times;</span>
    </div>
    <br>
  </div> -->




  <div>
    <img class="img-responsive" src="assets/images/banner.png" style="width:100%;height: 500px;">
  </div>
  <br>

<div class="key_style">
<b>SNAM Thermal</b> - Cloud based thermal analysis of your liquid metal, the first of its kind, aiding casting makers to meet their utmost quality.
SNAM Alloys proudly presents this as a biggest leap in extending our knowledge and experience gathered over years with our business partners.
<br>
<ul style="list-style: none;">
  <li><b style="color: red;">&#10147;</b>&nbsp;Metal Quality information readily available on your desktop</li>
  <li><b style="color: red;">&#10147;</b>&nbsp;Access the thermal properties of your metal and related data, anywhere in the world, with just internet connectivity</li>
</ul><br>
</div>
<br><br>
<div style="margin: auto;">

        <div class="row">
      <div class="col-md-12">
        <div class="aligncenter" style="transform: skew(-20deg);"><h2 class="head">SNAM THERMAL</h2></div>

      </div>
    </div>

   <div class="row">
            <div class="col-sm-4 info-blocks">
              <img src="assets/images/iot.png" alt="" />
                <div class="info-blocks-in">
                    <h3>IOT</h3>
                  <p>SNAM’s first IoT system – first of its kind</p>
                </div>
            </div>
            <div class="col-sm-4 info-blocks">
        <img src="assets/images/cloud based.png" alt="" /><br>
                <div class="info-blocks-in">
                    <h3>CLOUD BASED</h3>
                  <p>One of its kind-Cloud-based Thermal analysis system</p>
                </div>
            </div>
            <div class="col-sm-4 info-blocks">
        <img src="assets/images/interactive interface.png" alt="" /><br>
        <div class="info-blocks-in">
                    <h3>INTERACTIVE INTERFACE</h3>
                  <p>Interactive interface for Experts’ advice on metal quality</p>
                </div>
            </div>
        </div>
    <div class="row">
            <div class="col-sm-4 info-blocks">
        <img src="assets/images/data anytime anywhere.png" alt="" /><br>
        <div class="info-blocks-in">
                    <h3>DATA ANYTIME ANYWHERE</h3>
                  <p>Access the thermal properties of your metal and related data, anywhere in the world, with just internet connectivity</p>
                </div>
            </div>
            <div class="col-sm-4 info-blocks">
        <img src="assets/images/real time.png" alt="" /><br>
        <div class="info-blocks-in">
                    <h3>REAL TIME MONITORING</h3>
                  <p>Real-time monitoring of sample/metal pouring, from anywhere in the world, with just internet connectivity</p>
                </div>
            </div>
             </div>
</div>
<!-- <section class="section-padding gray-bg">

    <div class="row">
      <div class="col-md-12">
        <div class="section-title text-center">
          <h2>Our Organization</h2>
        <span>SNAM Company details</span></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <div class="about-text">
          <ul class="withArrow">
            <li><span class="fa fa-angle-right"></span>SNAM</li>
            <li><span class="fa fa-angle-right"></span>SNAM</li>
            <li><span class="fa fa-angle-right"></span>SNAM</li>
            <li><span class="fa fa-angle-right"></span>SNAM</li>
          </ul>
          <a href="#" class="Learn_btn">Learn More</a>
        </div>
      </div>
      <div class="col-md-6 col-sm-6">
        <div class="about-image">
          <img src="assets/images/product-banner-new.jpg" alt="About Images">
        </div>
      </div>
    </div>

   <div class="about home-about" style="font-size: 14px;">

          <div class="row">
            <div class="col-md-4">
              Heading and para
              <div style="color:red;font-weight:bold;">
                <h3><span><b>HEADING1</b></span></h3>
              </div>
        <p>
          SNAM Alloys Pvt Ltd., is one of the fastest growing and largest producer of Value Added Ferro Alloys in the world. With 30 years national and international presence in over 40 countries and 6 continents around the world, Snam today is the undisputed producer in India and Asia to collectively manufacture Ferro Silicon, Ferro Silicon Magnesium & Ferro Silicon based Inoculants.
           Leading automotive and engineering foundries spanning across the globe go for the trusted and reliable SNAM products to address their critical requirements.
        </p>
            </div>
            <div class="col-md-4">
              <div style="color:red;font-weight:bold;">
                <h3><span><b>HEADING2</b></span></h3>
              </div>
              Accordion starts
              <div class="panel-group" id="accordion-alt3">
                Panel. Use "panel-XXX" class for different colors. Replace "XXX" with color.
                <div class="panel">
                 Panel heading
                 <div class="panel-heading">
                  <h4 class="panel-title">
                    <a data-toggle="collapse" data-parent="#accordion-alt3" href="#collapseOne-alt3" ondblclick="document.getElementById('collapseOne-alt3').style.display='none;'">
                    <i class="fa fa-angle-right"></i>Heading Text Item # 1
                    </a>
                  </h4>
                 </div>
                 <div id="collapseOne-alt3" class="panel-collapse collapse">
                 Panel body
                  <div class="panel-body">
                  SNAM Alloys Pvt Ltd., is one of the fastest growing and largest producer of Value Added Ferro Alloys in the world. With 30 years national and international presence in over 40 countries and 6 continents around the world, Snam today is the undisputed producer in India and Asia to collectively manufacture Ferro Silicon, Ferro Silicon Magnesium & Ferro Silicon based Inoculants.</div>
                 </div>
                </div>
                <div class="panel">
                 <div class="panel-heading">
                  <h4 class="panel-title">
                    <a data-toggle="collapse" data-parent="#accordion-alt3" href="#collapseTwo-alt3">
                    <i class="fa fa-angle-right"></i>Heading Text Item # 2
                    </a>
                  </h4>
                 </div>
                 <div id="collapseTwo-alt3" class="panel-collapse collapse">
                  <div class="panel-body">
                    SNAM Alloys Pvt Ltd., is one of the fastest growing and largest producer of Value Added Ferro Alloys in the world. With 30 years national and international presence in over 40 countries and 6 continents around the world, Snam today is the undisputed producer in India and Asia to collectively manufacture Ferro Silicon, Ferro Silicon Magnesium & Ferro Silicon based Inoculants.										</div>
                 </div>
                </div>
                <div class="panel">
                 <div class="panel-heading">
                  <h4 class="panel-title">
                    <a data-toggle="collapse" data-parent="#accordion-alt3" href="#collapseThree-alt3">
                    <i class="fa fa-angle-right"></i>Heading Text Item # 3
                    </a>
                  </h4>
                 </div>
                 <div id="collapseThree-alt3" class="panel-collapse collapse">
                  <div class="panel-body">
                    SNAM Alloys Pvt Ltd., is one of the fastest growing and largest producer of Value Added Ferro Alloys in the world. With 30 years national and international presence in over 40 countries and 6 continents around the world, Snam today is the undisputed producer in India and Asia to collectively manufacture Ferro Silicon, Ferro Silicon Magnesium & Ferro Silicon based Inoculants.										</div>
                 </div>
                </div>
                <div class="panel">
                 <div class="panel-heading">
                  <h4 class="panel-title">
                    <a data-toggle="collapse" data-parent="#accordion-alt3" href="#collapseFour-alt3">
                    <i class="fa fa-angle-right"></i>Heading Text Item # 4
                    </a>
                  </h4>
                 </div>
                 <div id="collapseFour-alt3" class="panel-collapse collapse">
                  <div class="panel-body">
                    SNAM Alloys Pvt Ltd., is one of the fastest growing and largest producer of Value Added Ferro Alloys in the world. With 30 years national and international presence in over 40 countries and 6 continents around the world, Snam today is the undisputed producer in India and Asia to collectively manufacture Ferro Silicon, Ferro Silicon Magnesium & Ferro Silicon based Inoculants.
                  </div>
                 </div>
                </div>
              </div>
               Accordion ends

            </div>

            <div class="col-md-4">
              <div style="color:red;font-weight:bold;">
                <h3><span><b>HEADING3</b></span></h3>
              </div>
                   <div class="testimonials">
                  <div class="active item">
                    <blockquote><p>SNAM Alloys Pvt Ltd., is one of the fastest growing and largest producer of Value Added Ferro Alloys in the world. With 30 years national and international presence in over 40 countries and 6 continents around the world, Snam today is the undisputed producer in India and Asia to collectively manufacture Ferro Silicon, Ferro Silicon Magnesium & Ferro Silicon based Inoculants.</p></blockquote>
                    <div class="carousel-info">
                    <img alt="" src="assets/images/logo.png" class="pull-left">
                    <div class="pull-left">
                      <span class="testimonials-name">SNAM Alloys</span>
                      <span class="testimonials-post">Details</span>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
</section>	-->


<footer style="font-size: 16px;color:white;background-color: rgb(51, 47, 47);">
    <div class="row">
      <div class="col-sm-2">
        <div class="footer-logo">
          <a href="https://snam.co.in"><img src="https://snam.co.in/wp-content/themes/snam/images/footer-logo.png" alt="SNAM"></a>
        </div>
        </div>
      <div class="col-sm-10">
        <div class="footer-contact" >
          <h3>CONTACT</h3>
          <div class="row" >
            <div class="col-sm-4">
              <div class="sec-padding border-right">
                <p class="postal-address icons"><a href="https://goo.gl/maps/qDC37o8QMFC2" target="_blank">KARIAMANICKAM VILLAGE<br>
                  NETTAPAKKAM COMMUNE,<br>
                  PONDICHERRY – 605106.<br>
                  INDIA</a></p>
                </div>
            </div>
            <div class="col-sm-3">
              <div class="sec-padding border-right">
                <p class="postal-address icons"><a href="https://goo.gl/maps/DuPYxQohS22JiDw89" target="_blank">R&D CENTER<br>
                  No.138, SIPCOT PHASE I,<br>
                  HOSUR, TAMILNADU - 635126.<br>
                  INDIA</a></p>
                </div>
            </div>
         <div class="col-sm-4">
            <div class="sec-padding border-right">
              <p class="mobile icons">Phone : 04344 277799</p>
              <p class="email icons">Email : <a target="_blank" href="mailto:vprd@snam.co.in">vprd&#64;snam.co.in</a></p>
              <p class="email icons">Email : <a target="_blank" href="mailto:info@snam.co.in">info&#64;snam.co.in</a></p>
            </div>
            </div>
         </div>
  </div>
</div>
</div>
    <!-- <div id="sub-footer">
      <div class="row">
        <div class="col-lg-6">
          <div class="copyright">
            <p>
            <span>All rights reserved (c) Snam Alloys Private Limited 2018</span>	</p>
          </div>
        </div>
    <div class="col-lg-6">
          <ul class="social-network">
            <li><a href="#" data-placement="top" title="Facebook"><i class="fa fa-facebook"></i></a></li>
            <li><a href="#" data-placement="top" title="Twitter"><i class="fa fa-twitter"></i></a></li>
            <li><a href="#" data-placement="top" title="Linkedin"><i class="fa fa-linkedin"></i></a></li>
            <li><a href="#" data-placement="top" title="Pinterest"><i class="fa fa-pinterest"></i></a></li>
            <li><a href="#" data-placement="top" title="Google plus"><i class="fa fa-google-plus"></i></a></li>
          </ul>
        </div>
      </div>
    </div> -->
  </footer>
</ng-container>

